import { render, staticRenderFns } from "./OpacityCustoms.vue?vue&type=template&id=bad4b562"
import script from "./OpacityCustoms.vue?vue&type=script&lang=js"
export * from "./OpacityCustoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports